export enum NotificationsPanelState {
    Notifications = 'Notifications',
    Details = 'Details'
}
